import { motion } from "framer-motion";
import { Reveal, Overline } from "../Reveal";
import { INDUSTRIES } from "../../data/content";
import { Building2, Factory, ShoppingBag, Home, Hotel, GraduationCap, HeartPulse, HardHat, Landmark, Trophy } from "lucide-react";

const ICONS = [Building2, Factory, ShoppingBag, Home, Hotel, GraduationCap, HeartPulse, HardHat, Landmark, Trophy];

export const IndustriesGrid = ({ compact = false }) => (
  <section data-testid="industries-grid" className={`bg-sml-charcoal text-white ${compact ? "py-24" : "py-24 lg:py-32"}`}>
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="max-w-2xl mb-14">
        <Overline light>Industries We Serve</Overline>
        <Reveal>
          <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Solutions for Every Environment
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-white/60 leading-relaxed">
            Whatever your property environment, we tailor our services to meet your operational requirements.
          </p>
        </Reveal>
      </div>

      <div className="grid gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden sm:grid-cols-2 lg:grid-cols-5">
        {INDUSTRIES.map((name, i) => {
          const Icon = ICONS[i] || Building2;
          return (
            <motion.div
              key={name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: (i % 5) * 0.05 }}
              className="group bg-sml-charcoal p-7 hover:bg-sml-forest transition-colors duration-300"
              data-testid={`industry-${i}`}
            >
              <Icon className="h-7 w-7 text-sml-bronze" />
              <h3 className="mt-5 font-display text-lg leading-tight">{name}</h3>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
